export const passwordValidationPattern =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{10,}$/;
